import {
  dropdownTypes,
  validSettingKeys,
  validCheckboxKeys,
  OnDemandConfigItem
} from 'types/types';

export const validateJson = (inputJson: Array<OnDemandConfigItem>) => {
  if (!inputJson.length) {
    return true;
  }
  const validReportKeys = [
    'dagIdToTrigger',
    'descriptionText',
    'customSettings'
  ];
  const dagIds: Array<string> = [];
  const invalidReport = inputJson.some((report: OnDemandConfigItem) => {
    const reportKeys = Object.keys(report);
    if (
      !(
        validReportKeys.length === reportKeys.length &&
        validReportKeys.every((key) => reportKeys.includes(key))
      )
    ) {
      return true;
    }
    if (
      typeof report.dagIdToTrigger !== 'string' ||
      typeof report.descriptionText !== 'string'
    ) {
      return true;
    }
    dagIds.push(report.dagIdToTrigger);
    if (isSettingsInvalid(report.customSettings)) {
      return true;
    }
  });
  if (invalidReport) {
    return true;
  } else {
    return new Set(dagIds).size !== dagIds.length;
  }
};

const isSettingsInvalid = (customSettings: Array<object>) => {
  return customSettings.some((setting: any) => {
    const settingKeys = Object.keys(setting);
    const settingType = setting.type.split(' ').join('').toLowerCase();
    if (
      !validSettingKeys.every(
        (key) =>
          settingKeys.includes(key) &&
          (key === 'default' || typeof setting[key] === 'string')
      )
    ) {
      return true;
    }
    if (dropdownTypes.includes(settingType)) {
      if (
        !(
          settingKeys.includes('dropdownOptions') &&
          setting.dropdownOptions.length > 0 &&
          (settingType === 'dropdown' ||
            setting.dropdownOptions.every((option: any) =>
              validCheckboxKeys.every((key) =>
                Object.keys(option).includes(key)
              )
            ))
        )
      ) {
        return true;
      }
    }
  });
};
